'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresModal = function () {
    function WinresModal($scope) {
        _classCallCheck(this, WinresModal);

        this.$scope = $scope;
        //this.uibModalInstance
        this.$scope.item = this.resolve.item;
    }

    _createClass(WinresModal, [{
        key: '$onInit',
        value: function $onInit() {
            console.log("WinresModal! resolved items: ", this.resolve);
            // init stuff here
        }
    }]);

    return WinresModal;
}();

WinresModal.$inject = ['$scope'];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'WinresModal';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('WinresModal', require('./winresModal.html'));
}]);

_module3.default.component('winresModal', {
    templateUrl: getTemplate,
    controller: WinresModal,
    bindings: {
        modalInstance: "<",
        resolve: "<"
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresModal/winresModal.js
// module id = 497
// module chunks = 2